webpackJsonp([142629428675168],{

/***/ 470:
/***/ (function(module, exports) {

	module.exports = {"data":{"allContentfulBlogPost":{"edges":[{"node":{"title":"MSA's Guide to the July 2018 TLE","publicationDate":"July 12, 2018","thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/LbCHV5X20uOWOaOSqGq6k/4bc580240951e2736019196e961166c4/00.png"}}}},{"node":{"title":"Philippine Telescope Hour 2018","publicationDate":"February 02, 2018","thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/6DQs6bz2ZaGUso2AgwU86A/a2d5b98e0748904cf98334a71a6ca0c9/PTH_2018.jpg"}}}},{"node":{"title":"MSA featured by Verity","publicationDate":"December 27, 2017","thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/3mmTGWSJIQ0Sa48AGeQSaW/34fd68b76f37d9d678b546499e493066/cropped-verity-logo-v3.png"}}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-6baae6e10fefa17b573e.js